import api from './axios'

export interface EnrolmentClassItem {
  class_name: string
  student_count: number
  teacher_count?: number
}


export interface HOIEnrolmentResponse {
  school: {
    id: number
    school_id: string
    school_name: string
    district?: string
    district_id?: number
    school_type?: string
    management?: string
  }
  academic_year: string
  total_students: number
  enrolments: EnrolmentClassItem[]
}

export interface SaveHOIEnrolmentPayload {
  academic_year?: string
  school_id?: string
  teacher_count?: number
  enrolments: EnrolmentClassItem[]
}


export interface AnalyticsSummary {
  academic_year: string
  total_schools: number
  total_students: number
  total_teachers: number
  avg_ptr: number
  districts_count: number
  critical_ptr_schools: number
  warning_ptr_schools: number
  zero_teacher_schools: number
}

export interface SchoolAnalyticsRow {
  id: number
  school_id: string
  school_name: string
  district_id?: number | null
  district_name: string
  school_type: string
  management: string
  total_students: number
  total_teachers: number
  ptr_ratio: number | null
  ptr_status: 'normal' | 'warning' | 'critical' | 'zero_teachers' | string
  class_breakdown: EnrolmentClassItem[]
}

export interface DistrictSummaryItem {
  district_id: number | null
  district_name: string
  total_schools: number
  total_students: number
  total_teachers: number
  avg_ptr: number
  critical_ptr_schools: number
  warning_ptr_schools: number
  zero_teacher_schools: number
}

export interface AnalyticsReportResponse {
  success: boolean
  message?: string
  summary: AnalyticsSummary
  district_summary?: DistrictSummaryItem[]
  pagination: {
    total: number
    page: number
    limit: number
    total_pages: number
  }
  data: SchoolAnalyticsRow[]
}


export const enrolmentApi = {
  /**
   * Fetch HOI class-wise enrolment for logged-in HOI or specified school
   */
  async getHOIEnrolment(school_id?: string, academic_year: string = '2026-2027') {
    const params: Record<string, any> = { academic_year }
    if (school_id) params.school_id = school_id
    const response = await api.get<{ success: boolean; data: HOIEnrolmentResponse }>('/hois/enrolment', { params })
    return response.data
  },

  /**
   * Submit/upsert HOI class-wise enrolment
   */
  async saveHOIEnrolment(payload: SaveHOIEnrolmentPayload) {
    const response = await api.post<{ success: boolean; message: string; data: HOIEnrolmentResponse }>(
      '/hois/enrolment',
      payload
    )
    return response.data
  },

  /**
   * Get Admin / Minister school strength and PTR analytics dashboard report
   */
  async getAnalyticsReport(params?: {
    academic_year?: string
    district_id?: number
    school_id?: string
    school_type?: string
    management?: string
    search?: string
    ptr_status?: string
    page?: number
    limit?: number
  }) {
    const response = await api.get<AnalyticsReportResponse>('/analytics/enrolment-teacher-report', { params })
    return response.data
  }
}
